import setFullbanner from "./home/1_fullbanner";
import setBannersLinha from "./home/home_banner_linha";
import setCarousel from "../components/carousel";

//addImports

import setTopBar from "../components/topBar";
import handleConditionalLazy from "../components/conditionalLazy";

const Home = {
  init: function () {
    setTopBar();
    handleConditionalLazy();

    setFullbanner();
    setBannersLinha();
    setCarousel();

    //calls
  },
};

window.addEventListener("DOMContentLoaded", () => {
  Home.init();
});
